// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx","774":"framework"}[chunkId] || chunkId) + "-" + {"163":"5097bce26706e9d4e797","218":"79a313e916c51d054147","532":"6334b9f37ecbd407d79b","691":"ad42121eebe6d9d6ca58","774":"5eb81e7db30041a6b3da"}[chunkId] + ".js";
};